import { createContext } from "react";
import type { PreferenceContextValue } from "./types";

export const PreferencesContext = createContext<PreferenceContextValue | null>(null);

